<check-in-default-modal #seatRemovalModal [modalId]="'seatRemovalWarning_' + ssrType" modalTitle="{{'Seats removal warning' | translate: 'seatsremoval'}}"
  modalText="{{'Your selected options are not compatbile with some of the already selected seats. The next seats will be removed:' | translate: 'seatsremoval'}}" okButtonText="{{'Ok I agree' | translate: 'seatsremoval'}}"
  cancelButtonText="{{'Cancel' | translate:'seatsremoval'}}" [okRequired]="true" [cancelRequired]="true">
  <ul class="pending-list">
    <li *ngFor="let seat of seatsToBeRemoved">
      {{'{0} to {1}'|translate:'':seat.departureStation:seat.arrivalStation }} {{seat.unit}}
    </li>
  </ul>
</check-in-default-modal>